export enum CallToActionType {
  Email = 'EMAIL',
  WhatsApp = 'WHATS_APP'
}

export type HrefCallToAction = {
  type: CallToActionType.Email | CallToActionType.WhatsApp;
  text: string;
  href: string;
};
